import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictUsers } from '../../queries/getDataForDropdowns'
import { isEmpty } from 'lodash'
import { jsonPP } from '../utility/utility'
// props here holds the classes and pass it down
// the users data includes {id,name}, convert them to {value, lable}
const namePlaceholder = (props) => {
  const { companyId, departmentId } = props
  return (
    <Query query={dictUsers} variables={{ companyId, departmentId }} errorPolicy='all' fetchPolicy='network-only'>
      {({ loading, error, data }) => {
        // console.log(props)
        if (error) return jsonPP(error)
        if (loading) {
          return <p>Loading...</p>
        } else {
          const { helperText = 'Choose a user ...', labelText = '', ...rest } = props
          return (
            <AutoCompleteDropdown
              options={data.users.map((d) => ({
                // key: d.id,
                value: d.id,
                label: d.name,
                email: d.email,
                company: d.company,
                weight: d.weight,
                departmentName: isEmpty(d.department) ? '' : d.department.name,
                position: isEmpty(d.position) ? '' : d.position.name,
              }))}
              placeholder={helperText}
              labelText={labelText}
              {...rest}
            />
          )
        }
      }}
    </Query>
  )
}
//...d,
export default graphql(dictUsers)(namePlaceholder)
